import React from 'react'
import { Card } from 'primereact/card'
import { ShippingOrder } from '../../../DeShippingTableWrapper'

interface OrderSummaryKPIsProps {
  selectedOrders: ShippingOrder[]
}

export const OrderSummaryKPIs: React.FC<OrderSummaryKPIsProps> = ({
  selectedOrders
}) => {
  const totalItems = selectedOrders.reduce((sum, order) => sum + order.total_items, 0)
  const totalValue = selectedOrders.reduce((sum, order) => sum + order.order_subtotal, 0)

  return (
    <div className="mb-4 flex flex-direction-row">
      <h5 className="mb-3 flex align-items-center gap-2">
        <i className="pi pi-chart-line text-primary" style={{ fontSize: '1.25rem', marginRight: '8px' }}></i>
        Selected Orders Summary
      </h5>
      
      <div 
        className="p-3" 
        style={{ 
          display: 'flex', 
          justifyContent: 'space-around', 
          alignItems: 'center',
          width: '100%',
          gap: '16px'
        }}
      >
        <Card style={{ 
          textAlign: 'center', 
          flex: '1',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '12px',
          padding: '0',
          color: 'white',
          boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
          transition: 'transform 0.2s ease',
          border: 'none'
        }} className="p-0">
          <div style={{ padding: '12px 16px' }}>
            <div style={{ marginBottom: '4px' }}>
              <i className="pi pi-shopping-cart" style={{ fontSize: '1.6rem' }}></i>
            </div>
            <div style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '2px' }}>
              {selectedOrders.length}
            </div>
            <div style={{ fontSize: '0.85rem', opacity: '0.9' }}>
              Orders Selected
            </div>
          </div>
        </Card>

        <Card style={{ 
          textAlign: 'center', 
          flex: '1',
          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          borderRadius: '12px',
          padding: '0',
          color: 'white',
          boxShadow: '0 4px 15px rgba(240, 147, 251, 0.3)',
          transition: 'transform 0.2s ease',
          border: 'none'
        }} className="p-0">
          <div style={{ padding: '12px 16px' }}>
            <div style={{ marginBottom: '4px' }}>
              <i className="pi pi-box" style={{ fontSize: '1.6rem' }}></i>
            </div>
            <div style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '2px' }}>
              {totalItems}
            </div>
            <div style={{ fontSize: '0.9rem', opacity: '0.9' }}>
              Total Items
            </div>
          </div>
        </Card>

        <Card style={{ 
          textAlign: 'center', 
          flex: '1',
          background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
          borderRadius: '12px',
          padding: '0',
          color: 'white',
          boxShadow: '0 4px 15px rgba(79, 172, 254, 0.3)',
          transition: 'transform 0.2s ease',
          border: 'none'
        }} className="p-0">
          <div style={{ padding: '12px 16px' }}>
            <div style={{ marginBottom: '4px' }}>
              <i className="pi pi-dollar" style={{ fontSize: '1.6rem' }}></i>
            </div>
            <div style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '2px' }}>
              ${totalValue.toFixed(2)}
            </div>
            <div style={{ fontSize: '0.9rem', opacity: '0.9' }}>
              Total Value
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
} 